import api from "../api";

const routes = require("routes.js.erb");

// the component (emoji_reactions) and controller are type agnostic, but
// the actions need to be by type in order to correctly update state

const addItemReaction = async function({ dispatch }, params) {
  return api.post(routes.api_v5_reactions_path(), params).then(function() {
    // refetch the item to get the update count, reactable_id is the id of the item
    dispatch("getItem", params.reactable_id);
  });
};

/*
 * params: { reactionId: string (hashid of the reaction), itemId: string (hashid of the item) }
 */
const removeItemReaction = async function({ dispatch }, params) {
  return api.delete(`${routes.api_v5_reactions_path()}/${params.reactionId}`).then(function() {
    // refetch the item to get the update count
    dispatch("getItem", params.itemId);
  });
};

export {
  addItemReaction,
  removeItemReaction,
};
